import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const PaymentFailurePage = () => {
  const location = useLocation();
  const errorMessage = location.state?.error || 'Payment could not be completed.';

  return (
    <div className="flex min-h-screen items-center justify-center bg-[linear-gradient(135deg,#f8f4fb,#fff8f3)] px-4 py-8">
      <div className="w-full max-w-2xl rounded-3xl bg-white p-8 text-center shadow-2xl">
        <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-red-100 text-2xl text-red-600">
          !
        </div>
        <h1 className="mt-6 text-3xl font-bold text-gray-900">Payment Failed</h1>
        <p className="mt-3 text-sm text-gray-600">{errorMessage}</p>

        <div className="mt-8 flex flex-col gap-3 sm:flex-row">
          <Link
            to="/payment"
            className="inline-flex flex-1 items-center justify-center rounded-xl bg-gradient-to-r from-purple-600 to-orange-500 px-5 py-3 text-sm font-semibold text-white"
          >
            Try again
          </Link>
          <Link
            to="/"
            className="inline-flex flex-1 items-center justify-center rounded-xl border border-gray-300 px-5 py-3 text-sm font-semibold text-gray-700"
          >
            Back to home
          </Link>
        </div>
      </div>
    </div>
  );
};

export default PaymentFailurePage;
